
  import { css } from 'lit';
  export const styles = css`:host ::slotted([slot=label]){color:var(--header-text-color)}`;
  